import {
  INITIAL_MESSAGE,
  REMOVE_TASK_MESSAGE,
  UPDATE_TASK_MESSAGE,
} from "../actions/constants";

export enum SocketStatus {
  SUCCESS = "success",
  FAILED = "failed",
  INITIALIZED = "initialized",
  IN_PROGRESS = "in-progress",
}

export type SocketData = {
  status: SocketStatus;
  type: string;
  details?: any;
};

const reducer = (state: SocketData[] = [], action: any): SocketData[] => {
  switch (action.type) {
    case INITIAL_MESSAGE:
      return [...state, action.payload];
    case UPDATE_TASK_MESSAGE:
      return state
        ? state.map((data) =>
            action.payload.details?.task_id === data.details?.task_id
              ? action.payload
              : data
          )
        : [];
    case REMOVE_TASK_MESSAGE:
      return state
        ? state.filter((data) => action.payload !== data.details?.task_id)
        : [];
    default:
      return state;
  }
};

export default reducer;
